import { render, staticRenderFns } from "./perfect-user.vue?vue&type=template&id=71e2b7d8&scoped=true"
import script from "./perfect-user.vue?vue&type=script&lang=ts"
export * from "./perfect-user.vue?vue&type=script&lang=ts"
import style0 from "./perfect-user.vue?vue&type=style&index=0&id=71e2b7d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2b7d8",
  null
  
)

export default component.exports